/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
// @mui
import { Box, Container, IconButton, Tooltip, Typography, Button } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
// hooks
import { RemoveRedEye } from '@mui/icons-material';
import MaterialReactTable from 'material-react-table';
import { useNavigate } from 'react-router';
import useSettings from '../hooks/useSettings';
// components
import Page from '../components/Page';
import axiosInstance from '../Utilities/axios';
import { useSelector } from '../redux/store';

// ----------------------------------------------------------------------

export default function PayToBorrower() {
  const { themeStretch } = useSettings();
  const { User } = useSelector((state) => state.Login);
  const tokens = User.token;
  const Navigate = useNavigate();
  const [showloader, setshowloader] = useState(true);
  const [data, setData] = useState([]);

  const payNow = (detail) => {
    const paydetail = {
      name: detail?.name,
      email: detail?.email,
      payment_method: 'stripe',
      total: detail?.admin_pay_twenty_percent_loan,
      borrower_id: detail?.id,
      country: 'Country',
      contact: 'Contact',
      city: 'City',
    };
    console.log(paydetail, 'asdas');
    toast.loading();
    axiosInstance
      .post('payment', paydetail, {
        headers: {
          Authorization: `Bearer ${tokens}`,
        },
      })

      .then((response) => {
        if (response) {
          toast.remove();
          window.location.href = response?.data?.data;
        }
      })
      .catch((err) => {
        toast.remove();

        toast.error(err?.message);
        console.log(err);
      });
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: 'id',
        enableEditing: false,
        header: 'id',
      },

      {
        accessorKey: 'name',
        header: 'Borrower Name',
      },

      {
        accessorKey: 'email',
        header: 'Borrower email',
        size: 200,
      },
      {
        accessorKey: 'loan',
        header: 'Loan',
      },
      {
        accessorKey: 'title',
        header: 'Title',
      },
      {
        accessorKey: 'admin_pay_twenty_percent_loan',
        header: 'Pay 20% Amount',
      },

      {
        header: 'Pay Now',
        size: 250,
        Cell: ({ row }) => {
          return (
            <Box sx={{ display: 'flex', justifyContent: 'start' }}>
              <Tooltip arrow placement="right" title="Pay Now ">
                <Button onClick={() => payNow(row?.original)} variant="contained">
                  Pay Now
                </Button>
              </Tooltip>
            </Box>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    axiosInstance
      .get('/borrower', {
        headers: {
          Authorization: `Bearer ${tokens}`,
        },
        params: {
          is_admin_twenty_perct_send: false,
        },
      })
      .then((res) => {
        console.log(res, 'payment');
        if (res.data.status === true) {
          setshowloader(false);
          toast.success(res.data.message);
          setData(res?.data?.data);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, []);
  return (
    <Page title="Payment to borrower">
      {showloader && (
        <div>
          <div className="overlay" />
          <div className="loader" />
        </div>
      )}
      <Toaster position="top-right" reverseOrder={false} />
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Typography variant="h3" component="h1" paragraph>
          Pay 20% To Borrower
        </Typography>
        <MaterialReactTable
          columns={columns}
          data={data}
          //   renderDetailPanel={({ row }) => (
          //     <Box
          //       sx={{
          //         display: 'grid',
          //         margin: 'auto',
          //         gridTemplateColumns: '1fr 1fr',
          //         width: '100%',
          //       }}
          //     >
          //       <Typography>Address: {row.original.address}</Typography>
          //       <Typography>City: {row.original.city}</Typography>
          //       <Typography>State: {row.original.state}</Typography>
          //       <Typography>Country: {row.original.country}</Typography>
          //     </Box>
          //   )}
        />
      </Container>
    </Page>
  );
}
